<div
  class="fc-dropdown absolute top-full z-50"
  [ngStyle]="fcStyle"
  [class]="fcStyleClass"
  *ngIf="dropdownOpened">
  <ng-content></ng-content>
</div>
